import $ from 'jquery'
import moment from 'moment'
window.$ = $
window.jQuery = $

import './polyfill'

// Import Bootstrap JS (which depends on jQuery)
import 'bootstrap/dist/js/bootstrap'

import 'eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min'

import 'jquery-ujs'
import bootbox from 'bootbox'

// import 'jquery-ui/ui/widgets/datepicker'

import "../stylesheets/service_center.css"

$(function() {
  $('.datetimepicker').datetimepicker({format: 'YYYY-MM-DD'})
})

console.log('Service Center JS loaded')
